export default __webpack_public_path__ + "static/media/edit-xml.bf9a2847.png";